/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { PropsWithChildren } from 'react';
import { View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import Button, { ButtonProps } from './Button';
import { useBicyclehutTheme } from '../utils/paperTheme';

export type GradientButtonProps = ButtonProps & { buttonStyle?: ButtonProps['style'] };

const GradientButton = (props: PropsWithChildren<GradientButtonProps>) => {
  const { buttonStyle, rounded, narrow, style, loading, disabled } = props;
  const { colors, roundness, custom } = useBicyclehutTheme();

  const renderButton = () => {
    return (
      <Button textColor={colors.onPrimary} {...props} style={[{ borderWidth: 0, borderColor: 'unset' }, buttonStyle]} />
    );
  };

  const renderGradientButton = () => {
    return (
      <LinearGradient {...custom.gradientLayer1} style={{ borderRadius: rounded ? 24 : roundness }}>
        <LinearGradient {...custom.gradientLayer2} style={{ borderRadius: rounded ? 24 : roundness }}>
          {renderButton()}
        </LinearGradient>
      </LinearGradient>
    );
  };
  return (
    <View
      style={[
        {
          flexDirection: narrow ? 'row' : 'column',
          justifyContent: 'center',
        },
        style,
      ]}
    >
      {loading || disabled ? renderButton() : renderGradientButton()}
    </View>
  );
};
export default GradientButton;
